
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Mumbaiairporttopunecabservice() {



    const cardData =
    {
        keyword: 'Mumbai Airport to Pune Cab Service',
        heading: 'Morya Cabs: Mumbai Airport to Pune Cab Service',
        headingDescription: 'Morya Cabs offers efficient and comfortable Mumbai Airport to Pune cab service for a smooth and timely journey after your flight. Whether you are returning home, heading to a business meeting, or starting a vacation, our professional drivers and clean, well-equipped cabs ensure a relaxed travel experience. With 24/7 availability, hassle-free booking, and reliable service, Morya Cabs is your trusted choice for convenient transfers from Mumbai Airport to Pune.',

        top: 'Top Places to Visit in Pune  with Morya Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A majestic 18th-century fortification that served as the seat of the Peshwas from 1732. Though largely ruined by a fire in 1828, its surviving gates, ramparts, and foundation tell dramatic stories of Maratha politics and architecture. Don’t miss visiting at dusk for the evening light‑and‑sound show (check scheduling updates before planning)."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, this elegant palace is now a national monument commemorating Gandhi’s exile during the Quit India Movement. Its spacious lawns, serene interior, and informative museum exhibit key documents and personal items of Gandhi and Kasturba, making it a poignant pilgrimage for history lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "A historic hill‑fort about 28 km southwest of Pune, famed for the heroic Battle of Sinhagad (1670). You can hike up ~2.7 km or drive partway, then trek the rest. On top, explore bastions, temples, Tanaji’s memorial, and enjoy sweeping Sahyadri views—especially dramatic during monsoon."
    },
    {
        "title": "Dagdusheth Halwai Ganapati Temple",
        "description": "One of Pune’s most beloved and ornate Ganesha temples, known for its gold‑plated idol and philanthropic legacy. The lively atmosphere, frequent celebrations, and proximity to busy cultural neighborhoods make it a spiritual and sensory highlight."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved into Deccan basalt, featuring a monolithic Nandi shrine in an open mandapa supported by pillars. Nestled in urban greenery near Fergusson College, it's a peaceful oasis of ancient artistry."
    },
    {
        "title": "Parvati Hill & Temple",
        "description": "Pune’s second‑highest viewpoint at ~2,100 ft, accessed via 103 steps. The hilltop cluster of temples dates to the Peshwa era, offering panoramic views of the cityscape and a spiritual vibe—great for sunrise or evening visits."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A curated treasure trove of over 20,000 artifacts—ranging from Mughal miniatures to traditional puppets, musical instruments, and ornate brassware. The museum offers a vivid snapshot of India’s everyday art and crafts heritage."
    },
    {
        "title": "Osho International Meditation Resort",
        "description": "A serene urban retreat in Koregaon Park, offering a blend of dynamic meditation programs, communal events, and wellness sessions. The lush campus, eclectic architecture, and silent evenings provide a modern spiritual counterpoint to Pune’s heritage."
    },
    {
        "title": "Khadakwasla Dam & Lake",
        "description": "An evening hotspot just 20 km west of the city. The vantage point atop the dam offers scenic views over water and hills, especially during monsoon and winter. Locals gather for food stalls, kite flying, and relaxing lakeside strolls."
    },
    {
        "title": "Bhaja & Karla Buddhist Caves",
        "description": "Located along the Pune–Mumbai highway, these 2nd-century BCE cave complexes feature rock‑cut stupas and chaitya halls. Bhaja has 22 caves with a waterfall nearby, while Karla houses one of India’s largest ancient Buddhist prayer halls—impressive for history and architecture enthusiasts."
    }
],

  "services": [
  {
    "name": "Mumbai Airport to Pune Cab Service",
    "description": "Morya Cab offers a reliable and professional Mumbai Airport to Pune Cab Service that ensures a smooth and stress-free journey. Whether you land late at night or during peak hours, our fleet is ready to pick you up. Enjoy timely pickups, clean vehicles, and courteous drivers who prioritize your safety, comfort, and convenience throughout your travel from Mumbai Airport to Pune."
  },
  {
    "name": "Airport Pickup Taxi Mumbai to Pune",
    "description": "Choose Morya Cab for your airport pickup taxi from Mumbai to Pune. As part of our premium Mumbai Airport to Pune Cab Service, our drivers greet you at the arrival gate, assist with your luggage, and drive you comfortably through the expressway – making your intercity journey smooth and professional."
  },
  {
    "name": "One-Way Cab from Mumbai Airport to Pune",
    "description": "Looking for a one-way Mumbai Airport to Pune Cab Service? Morya Cab offers affordable and efficient one-way options without charging for the return trip. Ideal for tourists, students, or business travelers needing only a drop-off in Pune."
  },
  {
    "name": "Online Cab Booking Mumbai to Pune",
    "description": "Book your Mumbai Airport to Pune Cab Service online with Morya Cab in just a few clicks. Get instant booking confirmation, driver contact details, live tracking, and a seamless digital experience for your travel convenience."
  },
  {
    "name": "AC Taxi Mumbai to Pune",
    "description": "Experience comfort with our air-conditioned taxis under the Mumbai Airport to Pune Cab Service. Our clean, cool, and spacious AC vehicles make the 3-4 hour journey pleasant, no matter the season."
  },
  {
    "name": "Expressway Cab Mumbai Airport to Pune",
    "description": "Save time by booking Morya Cab’s expressway-based Mumbai Airport to Pune Cab Service. Our experienced drivers take the Mumbai-Pune Expressway to offer you a fast, efficient, and scenic travel route."
  },
  {
    "name": "Verified Cab Mumbai Airport Pune",
    "description": "Your safety is assured with our verified drivers and tracked vehicles. Morya Cab’s trusted Mumbai Airport to Pune Cab Service guarantees professionalism, safety, and peace of mind with every trip."
  },
  {
    "name": "Round Trip Cab Mumbai Pune",
    "description": "Morya Cab provides a convenient round-trip Mumbai Airport to Pune Cab Service with return options at discounted prices. Ideal for business meetings, same-day trips, or short Pune visits with a return plan."
  },
  {
    "name": "Airport Transfer Mumbai to Pune",
    "description": "Get smooth and reliable airport transfers with Morya Cab’s Mumbai Airport to Pune Cab Service. Whether flying in or out, enjoy timely pick-ups and drop-offs with our well-maintained cars and professional drivers."
  },
  {
    "name": "Private Sedan Mumbai Airport to Pune",
    "description": "Book a private sedan as part of our premium Mumbai Airport to Pune Cab Service. Perfect for executives, families, or couples seeking exclusivity, comfort, and privacy on their journey to Pune."
  },
  {
    "name": "24/7 Mumbai Airport Cab Pune",
    "description": "Available 24/7, Morya Cab offers around-the-clock Mumbai Airport to Pune Cab Service. No matter your flight time, we are ready to serve you – day or night, weekdays or weekends."
  },
  {
    "name": "Budget Cab Mumbai to Pune",
    "description": "Morya Cab offers a budget-friendly Mumbai Airport to Pune Cab Service that ensures quality without extra cost. Get affordable pricing, transparent billing, and top-notch service without compromising on safety or comfort."
  },
  {
    "name": "Fast Cab Mumbai to Pune City",
    "description": "Choose Morya Cab’s fast and efficient Mumbai Airport to Pune Cab Service for time-sensitive travel. Our drivers select the best routes and avoid traffic bottlenecks to get you to Pune quickly and safely."
  },
  {
    "name": "Reliable Mumbai to Pune Cab Hire",
    "description": "Morya Cab stands out for its reliable Mumbai Airport to Pune Cab Service. With thousands of satisfied customers, we’re known for punctuality, clean vehicles, trained drivers, and 24/7 customer support."
  },
  {
    "name": "Safe Travel Cab Mumbai Airport to Pune",
    "description": "With GPS tracking, hygiene protocols, and experienced drivers, Morya Cab ensures a safe and secure Mumbai Airport to Pune Cab Service tailored for families, solo travelers, and corporate clients alike."
  }
],
  "tableData": [
    ["Mumbai Airport to Pune Cab Service", "-Airport Pickup Taxi Mumbai to Pune"],
    ["One-Way Cab from Mumbai Airport to Pune", "-Online Cab Booking Mumbai to Pune"],
    ["AC Taxi Mumbai to Pune", "-Expressway Cab Mumbai Airport to Pune"],
    ["Verified Cab Mumbai Airport Pune", "-Round Trip Cab Mumbai Pune"],
    ["Airport Transfer Mumbai to Pune", "-Private Sedan Mumbai Airport to Pune"],
    ["24/7 Mumbai Airport Cab Pune", "-Budget Cab Mumbai to Pune"],
    ["Fast Cab Mumbai to Pune City", "-Reliable Mumbai to Pune Cab Hire"],
    ["Safe Travel Cab Mumbai Airport to Pune", "-Call Morya Cab at +91 9371304510"]
  ],




whychoose: [
    {
        "WhyChooseheading": "Punctual and Reliable Airport Pickup",
        "WhyChoosedescription": "Arriving at Mumbai Airport and need a smooth, hassle-free ride to Pune? Morya Cab offers reliable pickup services that ensure you start your journey on the right note. Our drivers monitor your flight status in real-time to adjust pickup times accordingly, so you never wait longer than necessary after landing, even if your flight is delayed or early."
    },
    {
        "WhyChooseheading": "Comfortable Vehicles for Long-Distance Travel",
        "WhyChoosedescription": "Traveling approximately 150 km from Mumbai Airport to Pune requires comfort and convenience. Our fleet includes air-conditioned sedans, SUVs, and luxury cars equipped with spacious seating and ample luggage space, ensuring you and your companions relax during the journey without any discomfort."
    },
    {
        "WhyChooseheading": "Experienced Drivers Skilled in Efficient Route Navigation",
        "WhyChoosedescription": "Our professional drivers are well-versed with all routes from Mumbai Airport to Pune, including the fastest highway options and alternate routes during peak traffic or roadblocks. Their expertise ensures a safe, smooth, and timely journey, allowing you to arrive at your Pune destination stress-free."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Morya Cab provides upfront pricing with no hidden fees for your Mumbai Airport to Pune ride. Our fares include fuel, tolls, parking, and driver allowances, ensuring you know exactly what you’re paying for. Choose from affordable one-way rides or round-trip packages tailored to your travel needs."
    },
    {
        "WhyChooseheading": "24/7 Availability to Match Flight Schedules",
        "WhyChoosedescription": "Flights operate round the clock, and so do we. Whether you arrive early morning or late at night, Morya Cab’s customer support and drivers are available 24/7 to provide timely pickups from Mumbai Airport, making your transition to Pune seamless regardless of your flight timing."
    },
    {
        "WhyChooseheading": "Real-Time Flight Monitoring and Traffic Updates",
        "WhyChoosedescription": "Our service includes live flight tracking and traffic monitoring to optimize your pickup schedule and route. We stay updated with Mumbai Airport arrivals and use traffic apps to avoid congestion, ensuring your journey to Pune is as quick and smooth as possible."
    },
    {
        "WhyChooseheading": "Simple Booking with Multiple Payment Options",
        "WhyChoosedescription": "Book your Mumbai Airport to Pune cab easily through our website, app, or customer service hotline. Enjoy instant booking confirmation, live cab tracking, and convenient payment options including credit/debit cards, UPI, net banking, or cash. We make the booking process hassle-free so you can focus on your trip."
    },
    {
        "WhyChooseheading": "Ideal for Business and Family Travelers",
        "WhyChoosedescription": "Whether you’re a corporate traveler needing prompt service or a family returning from a trip, Morya Cab caters to all your needs. We offer spacious vehicles, child safety seats upon request, and courteous drivers to make your airport transfer comfortable and personalized."
    }
]


















    }

const faqData = [
  {
    question: "How can I book a Mumbai Airport to Pune cab with Morya Cab?",
    answer: "Booking is simple—just use our website, mobile app, or call our 24/7 customer support for immediate assistance after your flight lands."
  },
  {
    question: "Do you offer pickup from both Terminal 1 and Terminal 2 at Mumbai Airport?",
    answer: "Yes, we offer cab pickups from both T1 (domestic) and T2 (international) terminals. Just share your flight details during booking."
  },
  {
    question: "What is the distance and travel time from Mumbai Airport to Pune?",
    answer: "The journey is around 160–180 km and takes approximately 3.5 to 5 hours, depending on traffic and your drop location in Pune."
  },
  {
    question: "Are your cabs available late at night or early morning?",
    answer: "Yes, our services operate 24x7, including late night and early morning airport pickups. We ensure timely pickups regardless of your flight time."
  },
  {
    question: "Will the driver wait if my flight is delayed?",
    answer: "Yes, we monitor flight delays and adjust your cab’s pickup time accordingly to ensure a hassle-free experience even if your flight is late."
  },
  {
    question: "What types of vehicles are available for the airport transfer?",
    answer: "We offer hatchbacks, sedans, SUVs, and tempo travelers based on your luggage, comfort, and group size requirements."
  },
  {
    question: "Can I book the cab in advance before my flight to Mumbai?",
    answer: "Yes, advance bookings are recommended. Share your flight number and arrival time, and we’ll arrange everything for you in advance."
  },
  {
    question: "What payment methods are accepted?",
    answer: "We accept UPI, credit/debit cards, net banking, and cash. Online payment links are also available during booking confirmation."
  },
  {
    question: "Is the service suitable for family, solo, or corporate travel?",
    answer: "Absolutely. Whether you're traveling alone, with family, or for business, we have the right cab and service quality to meet your needs."
  },
  {
    question: "Why choose Morya Cab for Mumbai Airport to Pune travel?",
    answer: "Morya Cab provides reliable, safe, and affordable airport transfers with real-time flight tracking, experienced drivers, and 24/7 support."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Sagar Jadhav',
    role: 'IT Professional',
    review: 'After a long international flight, Morya Cab was ready at Mumbai Airport. The driver was polite and the ride to Pune was smooth and relaxing.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Mrs. Neha Kulkarni',
    role: 'Frequent Flyer',
    review: 'Excellent service! The driver waited patiently even after my flight was delayed. Safe, clean, and perfectly timed transfer to Pune.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];










      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


   
   
const mumbaiAirportToPuneCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cab Service",
  "image": "https://moryacab.com/assets/images/mumbai-airport-to-pune-cab.jpg",
  "description": "Book reliable Mumbai Airport to Pune cab service with Morya Cabs. Choose AC sedan, SUV, or tempo traveller for safe and comfortable airport transfers. Available for one-way and round trip with verified drivers and 24/7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Morya Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "10450",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2699",
    "availability": "https://schema.org/InStock",
    "url": "https://moryacab.com/mumbai-airport-to-pune-cab-service"
  }
};










    return (
        <div>
            <UsePageTracking/>

<Helmet>
  <title>Mumbai Airport to Pune Cab Service | AC Sedan, SUV & Tempo Traveller | Morya Cabs</title>
  <meta
    name="description"
    content="Book reliable Mumbai Airport to Pune cab service with Morya Cabs. Choose AC sedan, SUV, or tempo traveller for safe and comfortable airport transfers. Available for one-way and round trip with verified drivers and 24/7 support."
  />
  <meta
    name="keywords"
    content="Mumbai Airport to Pune Cab, Airport Taxi Mumbai to Pune, AC Taxi Mumbai Pune Airport, SUV Cab Mumbai to Pune, Tempo Traveller Airport Transfer, One-Way Airport Cab Mumbai Pune, Round Trip Pune Taxi, Morya Cabs Airport Transfer, Verified Drivers Airport Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAirportToPuneCabSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/108.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaiairporttopunecabservice;